import { Controller } from '@hotwired/stimulus';
import {
  debounce,
  eventListener,
} from '@inked/utilities';

export class ScrollViewController extends Controller {
  static targets = [ 'backward', 'forward', 'item', 'view' ];
  static values = {
    behavior: {
      default: 'smooth',
      type: String,
    },
    loop: {
      default: false,
      type: Boolean,
    },
    step: {
      default: 1,
      type: Number,
    },
  };

  backward() {
    if (
      this.loopValue
      && this.scrollAtStart
    ) {
      this.viewTarget.scrollTo({ left: this.viewTarget.scrollWidth, behavior: this.behaviorValue });

      return;
    }

    this.viewTarget.scrollBy({ left: -this.scrollAmount(), behavior: this.behaviorValue });
  }

  connect() {
    this.stopScrollEvent = eventListener(this.viewTarget, 'scroll', debounce(() => this.onScroll()));
  }

  disconnect() {
    this.stopScrollEvent();
  }

  forward() {
    if (
      this.loopValue
      && this.scrollAtEnd
    ) {
      this.viewTarget.scrollTo({ left: 0, behavior: this.behaviorValue });

      return;
    }

    this.viewTarget.scrollBy({ left: this.scrollAmount(), behavior: this.behaviorValue });
  }

  onScroll() {
    if (this.loopValue) return;

    if (this.hasBackwardTarget) this.backwardTargets.forEach(backward => backward.disabled = this.scrollAtStart);
    if (this.hasForwardTarget) this.forwardTargets.forEach(forward => forward.disabled = this.scrollAtEnd);
  }

  scrollAmount() {
    if (this.hasItemTarget) {
      return this.itemTarget.offsetWidth * this.stepValue;
    }

    return this.viewTarget.offsetWidth * this.stepValue;
  }

  get scrollAtEnd() {
    return this.viewTarget.scrollLeft + this.viewTarget.clientWidth === this.viewTarget.scrollWidth;
  }

  get scrollAtStart() {
    return this.viewTarget.scrollLeft === 0;
  }
}
